export default __webpack_public_path__ + "static/media/slice-sidebar-annotations.56266a25.png";